module.exports = __webpack_public_path__ + "img/cliente02.ba37e8f9.jpg";